import { Component } from "react";
import "./navbarStyles.css";
import { MenuItems } from "./MenuItems";
import { Link } from "react-router-dom";

class Navbar extends Component {
  state = { clicked: false };
  handleClick = () => {
    this.setState({ clicked: !this.state.clicked });
  };
  
  render() {
    return (
      <nav className="NavbarItems">
        <h1 className="navbar-logo">Tripping House</h1>

        <div className="menu-icons" onClick={this.handleClick}>
          <i
            className={
              this.state.clicked
                ? "fa-solid fa-circle-xmark"
                : "fa-solid fa-bars"
            }
          ></i>
        </div>

        <ul className={this.state.clicked? "nav-menu active" :"nav-menu"}>
          {MenuItems.map((item, index) => {
            return (
              <li key={index}>
                <Link className={item.cName} to={item.url}>
                  <i className={item.icons}></i>
                  {item.title}{" "}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    );
  }
}

export default Navbar;
